import React from "react";
import Button from "../shared/Button/Button";

interface LoginPageBtnProps {
  label: any;
  onClick: () => any;
  type?: "submit" | "reset" | "button";
  loading?: boolean;
  className?: string;
}

const LoginPageBtn: React.FC<LoginPageBtnProps> = ({
  label,
  type = "button",
  onClick,
  loading,
  className = "",
}) => {
  return (
    <Button
      onClick={onClick}
      type={type}
      loading={loading}
      className={`w-full font-bold py-2.5 text-[13px] text-black flex justify-center items-center rounded-md gap-2 focus:outline-none ${className}`}
    >
      {label}
    </Button>
  );
};

export default LoginPageBtn;
